var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2852_43643)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2852_43643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.292542 0.292593C0.48007 0.105122 0.734378 -0.000193557 0.999542 -0.000193557C1.26471 -0.000193557 1.51901 0.105122 1.70654 0.292593L7.99954 6.58559L14.2925 0.292593C14.3848 0.197083 14.4951 0.1209 14.6171 0.0684915C14.7391 0.0160825 14.8704 -0.0115037 15.0031 -0.0126576C15.1359 -0.0138114 15.2676 0.0114903 15.3905 0.0617712C15.5134 0.112052 15.625 0.186305 15.7189 0.280198C15.8128 0.374091 15.8871 0.485743 15.9374 0.608639C15.9876 0.731535 16.0129 0.863215 16.0118 0.995994C16.0106 1.12877 15.9831 1.25999 15.9306 1.382C15.8782 1.504 15.8021 1.61435 15.7065 1.70659L9.41354 7.99959L15.7065 14.2926C15.8887 14.4812 15.9895 14.7338 15.9872 14.996C15.9849 15.2582 15.8798 15.509 15.6944 15.6944C15.509 15.8798 15.2581 15.985 14.9959 15.9873C14.7337 15.9895 14.4811 15.8888 14.2925 15.7066L7.99954 9.41359L1.70654 15.7066C1.51794 15.8888 1.26534 15.9895 1.00314 15.9873C0.740944 15.985 0.490132 15.8798 0.304724 15.6944C0.119316 15.509 0.0141467 15.2582 0.0118683 14.996C0.00958985 14.7338 0.110384 14.4812 0.292542 14.2926L6.58554 7.99959L0.292542 1.70659C0.105071 1.51907 -0.000244141 1.26476 -0.000244141 0.999593C-0.000244141 0.734429 0.105071 0.480121 0.292542 0.292593Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2852_43643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2852_43643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.84abfed42bd95a219ef594c8ff2a42f4.svg";
export { ForwardRef as ReactComponent };